<template>
  <svg
    id="svg2"
    xmlns:dc="http://purl.org/dc/elements/1.1/"
    xmlns:cc="http://creativecommons.org/ns#"
    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 400 400"
    height="400"
    width="400"
    xml:space="preserve"
    version="1.1">
    <metadata id="metadata8">
      <rdf:RDF>
        <cc:Work rdf:about>
          <dc:format>image/svg+xml</dc:format>
          <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        </cc:Work>
      </rdf:RDF>
    </metadata>
    <defs id="defs6">
      <clipPath id="clipPath18" clipPathUnits="userSpaceOnUse">
        <path
          id="path16"
          d="M 150,300 C 67.157,300 0,232.843 0,150 v 0 C 0,67.157 67.157,0 150,0 v 0 c 82.843,0 150,67.157 150,150 v 0 c 0,82.843 -67.157,150 -150,150 z" />
      </clipPath>
    </defs>
    <g id="g10" transform="matrix(1.3333333,0,0,-1.3333333,0,400)">
      <g id="g12">
        <g id="g14" clip-path="url(#clipPath18)">
          <path
            id="path20"
            style="fill:#009e49;fill-opacity:1;fill-rule:nonzero;stroke:none"
            d="M -50,300 H 550 V 200 H -50 Z" />
          <path
            id="path22"
            style="fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none"
            d="M -50,200 H 550 V 100 H -50 Z" />
          <path
            id="path24"
            style="fill:#000000;fill-opacity:1;fill-rule:nonzero;stroke:none"
            d="M -50,100 H 550 V 0 H -50 Z" />
          <path
            id="path26"
            style="fill:#ce1126;fill-opacity:1;fill-rule:nonzero;stroke:none"
            d="M -50,300 H 100 V 0 H -50 Z" />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Ar',
};
</script>
